(function () {
  var requestId = 0;
  var arrow =
    '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  function carsLabel(n) {
    var mod10 = n % 10;
    var mod100 = n % 100;
    var word = 'vozů';
    if (n === 1) word = 'vůz';
    else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) word = 'vozy';
    return n + ' ' + word;
  }

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function kc(cents) {
    var amount = Math.round(Number(cents) / 100);
    return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function linkHref(offer, makeParam, modelParam) {
    var params = new URLSearchParams();
    params.set(makeParam, offer.make_gid);
    params.set(modelParam, offer.model_gid);
    return window.location.pathname + '?' + params.toString();
  }

  function cardHtml(offer, note, buttonLabel, extra) {
    var title = offer.title || [offer.make, offer.model, offer.trim].filter(Boolean).join(' ');
    var alt = title + ' na operativní leasing';
    var chips = [offer.type, offer.fuel, offer.trim, carsLabel(offer.count || 1)].filter(Boolean);
    var meta =
      '<ul class="offer-list__meta">' +
      chips
        .map(function (chip) {
          return '<li>' + esc(chip) + '</li>';
        })
        .join('') +
      '</ul>';
    var image = offer.image
      ? '<img src="' +
        esc(offer.image) +
        '" alt="' +
        esc(alt) +
        '" width="480" height="360" loading="lazy" decoding="async" fetchpriority="low">'
      : '';
    var about = offer.about ? '<p>' + esc(offer.about) + '</p>' : '';
    var noteWith = String(note || '').replace('bez DPH', 's DPH');
    var priceWithout = offer.price_text || kc(offer.price);
    var priceWith = kc(Math.round((Number(offer.price) / 100) * 1.21) * 100);
    var label = buttonLabel || 'Zobrazit detail';
    return (
      '<li class="offer-list__item' +
      (extra ? ' is-extra" hidden' : '"') +
      '>' +
      image +
      '<h3>' +
      esc(title) +
      '</h3>' +
      meta +
      about +
      '<span class="offer-list__price"><span class="withoutVat">od ' +
      esc(priceWithout) +
      ' Kč<span class="offer-list__vat">' +
      esc(note) +
      '</span></span><span class="withVat">od ' +
      esc(priceWith) +
      ' Kč<span class="offer-list__vat">' +
      esc(noteWith) +
      '</span></span></span>' +
      '<span class="offer-list__btn"><span class="offer-list__btn-full">' +
      esc(label) +
      '</span><span class="offer-list__btn-short">' +
      esc(label.split(' ')[0]) +
      '</span>' +
      arrow +
      '</span><a href="' +
      esc(offer.url || '#') +
      '" aria-label="' +
      esc(label + ' ' + alt) +
      '"></a></li>'
    );
  }

  function mergeOffers(rows) {
    var order = [];
    var map = {};
    rows.forEach(function (row) {
      if (!row || !row.offers) return;
      row.offers.forEach(function (offer) {
        if (!offer || !offer.id) return;
        var current = map[offer.id];
        if (!current) {
          map[offer.id] = offer;
          order.push(offer.id);
          return;
        }
      });
    });
    return order.map(function (id) {
      return map[id];
    });
  }

  function linkHtml(offers, makeParam, modelParam) {
    var seen = {};
    var html = '';
    var count = 0;
    offers.forEach(function (offer) {
      var key = offer.make_gid + '|' + offer.model_gid;
      if (!offer.make_gid || !offer.model_gid || seen[key]) return;
      seen[key] = true;
      count += 1;
      var label = [offer.make, offer.model].filter(Boolean).join(' ');
      html += '<li><a href="' + esc(linkHref(offer, makeParam, modelParam)) + '">' + esc(label) + '</a></li>';
    });
    return html;
  }

  function refreshCollectionOffers() {
    var root = document.querySelector('[data-offer-list]');
    if (!root) return;
    var grid = root.querySelector('[data-offer-list-grid]');
    if (!grid) return;

    var id = (requestId += 1);

    function loadPage(page) {
      return fetch(window.location.pathname + '?view=offers&page=' + page, { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    loadPage(1)
      .then(function (first) {
        if (!first) return [];
        var pages = Math.max(1, Number(first.pages) || 1);
        var jobs = [Promise.resolve(first)];
        for (var page = 2; page <= pages; page += 1) jobs.push(loadPage(page));
        return Promise.all(jobs);
      })
      .then(function (rows) {
        if (id !== requestId) return;
        if (!root.isConnected) return;
        var offers = mergeOffers(rows || []).filter(function (offer) {
          return offer && offer.price != null && offer.url;
        });
        if (!offers.length) return;
        var tallies = {};
        var mins = {};
        offers.forEach(function (offer) {
          var key = [offer.make_gid, offer.model_gid, offer.trim].join('|');
          tallies[key] = (tallies[key] || 0) + 1;
          if (mins[key] == null || offer.price < mins[key].price) {
            mins[key] = { price: offer.price, price_text: offer.price_text };
          }
        });
        offers.forEach(function (offer) {
          var key = [offer.make_gid, offer.model_gid, offer.trim].join('|');
          offer.count = tallies[key];
          if (mins[key]) {
            offer.price = mins[key].price;
            offer.price_text = mins[key].price_text;
          }
        });

        var note = root.getAttribute('data-price-note') || 'měsíčně bez DPH';
        var buttonLabel = root.getAttribute('data-card-button') || 'Zobrazit detail';
        var makeParam = root.getAttribute('data-make-param') || 'filter.p.m.custom.car_make';
        var modelParam = root.getAttribute('data-model-param') || 'filter.p.m.custom.car_model';
        var open = root.getAttribute('data-offers-open') === 'true';
        grid.innerHTML = offers
          .map(function (offer, index) {
            return cardHtml(offer, note, buttonLabel, !open && index >= 8);
          })
          .join('');
        var more = root.querySelector('[data-offer-list-more]');
        var less = root.querySelector('[data-offer-list-less]');
        if (more) more.hidden = open || offers.length <= 8;
        if (less) less.hidden = !open || offers.length <= 8;
        var links = root.querySelector('[data-offer-list-links]');
        if (links) {
          links.innerHTML = linkHtml(offers, makeParam, modelParam);
          if (links.parentElement) links.parentElement.scrollLeft = 0;
        }
        initOfferScroller(root);
      });
  }

  function initOfferScroller(root) {
    var wrap = (root || document).querySelector('[data-offer-list-scroller]');
    if (!wrap) return;
    var track = wrap.querySelector('.offer-list__track');
    var btnL = wrap.querySelector('.offer-list__arrow--left');
    var btnR = wrap.querySelector('.offer-list__arrow--right');
    if (!track || !btnL || !btnR) return;

    function update() {
      var s = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;
      if (s <= 2) {
        btnL.classList.add('is-hidden');
        btnL.setAttribute('hidden', '');
      } else {
        btnL.classList.remove('is-hidden');
        btnL.removeAttribute('hidden');
      }
      if (max < 2 || s >= max - 2) btnR.classList.add('is-hidden');
      else btnR.classList.remove('is-hidden');
    }

    wrap._offerLinksUpdate = update;
    if (wrap._offerLinksInited) {
      update();
      return;
    }
    wrap._offerLinksInited = true;

    track.addEventListener('scroll', update, { passive: true });
    update();

    btnL.addEventListener('click', function () {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    });
    btnR.addEventListener('click', function () {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
    });

    var prevX = 0;
    var startX = 0;
    var dragging = false;
    var hasDragged = false;
    var pendingId = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      prevX = e.clientX;
      startX = e.clientX;
      pendingId = e.pointerId;
      hasDragged = false;
    });

    track.addEventListener('pointermove', function (e) {
      if (pendingId === null) return;
      if (e.buttons === 0) {
        endDrag();
        return;
      }
      if (!dragging) {
        if (Math.abs(e.clientX - startX) < 5) return;
        dragging = true;
        track.setPointerCapture(pendingId);
        track.classList.add('is-dragging');
      }
      hasDragged = true;
      track.scrollTo({ left: track.scrollLeft + (prevX - e.clientX) * 0.6, behavior: 'instant' });
      prevX = e.clientX;
    });

    function endDrag() {
      dragging = false;
      pendingId = null;
      track.classList.remove('is-dragging');
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener(
      'click',
      function (e) {
        if (!hasDragged) return;
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      },
      true,
    );
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
    window.addEventListener('resize', update);
  }

  var offersObserver = null;

  function scheduleCollectionOffers() {
    var root = document.querySelector('[data-offer-list]');
    if (!root) return;
    if (offersObserver) offersObserver.disconnect();
    if (!('IntersectionObserver' in window)) {
      refreshCollectionOffers();
      return;
    }
    offersObserver = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (entry) {
            return entry.isIntersecting;
          })
        )
          return;
        offersObserver.disconnect();
        offersObserver = null;
        refreshCollectionOffers();
      },
      { rootMargin: '600px 0px' },
    );
    offersObserver.observe(root);
  }

  function setOffersOpen(root, open) {
    root.setAttribute('data-offers-open', open ? 'true' : 'false');
    root.querySelectorAll('.offer-list__item.is-extra').forEach(function (item) {
      item.hidden = !open;
    });
    var more = root.querySelector('[data-offer-list-more]');
    var less = root.querySelector('[data-offer-list-less]');
    if (more) more.hidden = open;
    if (less) less.hidden = !open;
    if (!open) root.scrollIntoView({ block: 'nearest' });
  }

  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-offer-list-more]');
    var less = event.target.closest('[data-offer-list-less]');
    var button = more || less;
    if (!button) return;
    var root = button.closest('[data-offer-list]');
    if (!root) return;
    setOffersOpen(root, !!more);
  });

  window.refreshCollectionOffers = scheduleCollectionOffers;
  initOfferScroller();
  scheduleCollectionOffers();
})();
